/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/requestFlightMiles/directives/datePicker.js
*    TO   --> ./legacy-web/src/main/assets/js/request-flight-miles/directives/date-picker.js
**/

var RFM_APP = angular.module("RFM_APP");

RFM_APP.directive("datepicker", ["$timeout", function ($timeout) {

    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, elem, attrs, ngModelCtrl) {

            var updateModel = function (dateText) {
                scope.$apply(function () {
                    ngModelCtrl.$setViewValue(dateText);
                });
            };
            var options = {
                minDate: -365,
                maxDate: -3,
                dateFormat:$j("#formSearchController").attr("datePickerDateFormat").replace("yyyy", "yy").replace("aaaa", "yy").replace("jj", "dd"),
                onSelect: function (dateText) {
                    updateModel(dateText);
                },
	            onClose: function (dateText, inst) {
	            	elem.focus();
	            }
            };

            $timeout(function () {
                elem.datepicker(options);
            }, 0);

        }
    };
}]);
